// extracted by mini-css-extract-plugin
export default {"brn_scroll_to_up_container":"ScrollToUpBtn_brn_scroll_to_up_container__3gWWn","arrow_up":"ScrollToUpBtn_arrow_up__QlnTC"};